import PropTypes from 'prop-types';

function ExternalLink({ children, href, safe, ...restProps }) {
  // Consider https://healthy.io links as safe (allows sub-domains as well)
  const isHealthyLink =
    href && href.match(/^https:\/\/([a-zA-Z\d-]+\.){0,}healthy\.io$/);

  return (
    <a
      href={href}
      rel={safe ?? isHealthyLink ? '' : 'noreferrer noopener'}
      target="_blank"
      {...restProps}
    >
      {children}
    </a>
  );
}

ExternalLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  /** Consider the link safe. Won't apply rel="noreferrer noopener" */
  safe: PropTypes.bool,
};

export default ExternalLink;
